import { render, staticRenderFns } from "./AccountHolderNotionalAccounts.vue?vue&type=template&id=d9a86dd2&scoped=true"
import script from "./AccountHolderNotionalAccounts.vue?vue&type=script&lang=ts"
export * from "./AccountHolderNotionalAccounts.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderNotionalAccounts.vue?vue&type=style&index=0&id=d9a86dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a86dd2",
  null
  
)

export default component.exports